<template>
  <div
    ref="dust-wipe-value"
    :data-tippy-content="$wording.certify.error_threshold"
    class="field has-addons"
  >
    <div class="control is-expanded has-icons-right">
      <textbox
        :value="value"
        :name="name"
        tabindex="0"
        type="number"
        rules="required"
        placeholder="Value"
        min="0"
        required
        @keydown.189="minusKeyError"
        @change.native.stop="processNumber"
        @blur.native.stop="processNumber"
      />
      <span class="icon is-small is-right dust-wipe-wrong-icon">
        <i
          class="fas fa-exclamation-circle"
          aria-hidden="true"
        />
      </span>
    </div>
    <div class="control">
      <span class="button is-symbol is-static">
        µg/ft
        <sup>2</sup>
      </span>
    </div>
  </div>
</template>

<script>
import tippy from 'tippy.js';

export default {
  name: 'DustWipeValue',
  components: {
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    enableTippy: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [ Number ],
      default: null,
    },
  },
  data() {
    return {
      tooltipInstance: null,
    };
  },
  watch: {
    enableTippy() {
      this.setTooltipState();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tooltipInstance = tippy(this.$refs['dust-wipe-value'], {
        theme: 'material',
        arrow: true,
        maxWidth: 300,
      });

      this.setTooltipState();
    });
  },
  methods: {
    minusKeyError($event) {
      this.$warning(this.$wording.certify.negative_error);
      $event.preventDefault();
    },
    setTooltipState() {
      if (this.tooltipInstance) {
        if (this.enableTippy) {
          this.tooltipInstance.enable();
        } else {
          this.tooltipInstance.disable();
        }
      }
    },
    processNumber($event) {
      try {
        let slice = String($event.target.value).indexOf('.') === -1 ? 3 : 6;
        let value = Number(String($event.target.value).replace(/\D\./g,'').slice(0, slice)).toFixed(2);
        $event.target.value = value;
        this.$emit('input', Math.abs(value));
      } catch (err) {
        $event.target.value = 0;
        this.$emit('input', 0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .button {
    &.is-symbol {
      text-transform: none;
      background-color: $ghost-gray;
      border-color: $ghost-gray;
      color: $dark-gray;
    }
  }
</style>